import React from "react";
import { Select, Button, Text } from "@chakra-ui/react";

const Assessment = ({ formHandler }) => {
  return (
    <div>
      <Text my={4}>At the end of curriculum, tutors will take this exam</Text>
      <p></p>
      <Select
        name="exam"
        id="exam"
        onChange={formHandler.handleChange}
        value={formHandler.values.exam}
        isRequired
        placeholder="Select Exam"
      >
        <option value="option1">Option 1</option>
        <option value="option2">Option 2</option>
        <option value="option3">Option 3</option>
      </Select>
      <Button sx={{ position: "absolute", bottom: "30%", right: "10%" }}>
        Create Exam
      </Button>
    </div>
  );
};

export default Assessment;
